import React, {FC, useState} from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Drawer from "react-modern-drawer"
import tracking from "@irati-tracking/platform/platform"
import Flex from "../Flex"
import Icon, {IconTypes} from "../Icon"
import Spacing from "../Spacing"
import ToastAlert from "../ToastAlert"
import {triggerSuccessToast} from "../ToastAlert/triggerToast"
import {DrawerData} from "../AppContainer/Context/DrawerContext"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"
import {Body} from "@irati/ui/src/Typography"

interface Props {
  show: boolean
  data: DrawerData
  onClose: () => void
}

const ShareToDrawer: FC<Props> = ({show, onClose, data}) => {
  const {formatMessage} = useIntl()
  const [showAlert, setShowAlert] = useState(true)
  const {title, url, alertText, source, type, entity_id} = data

  const sharingData = {
    title,
    url
  }

  const handleClickShare = () => {
    navigator.share(sharingData).then(() => {
      tracking.share({source, type, entity_id})
      onClose()
    })
  }

  const handleCopyClick = () => {
    triggerSuccessToast(formatMessage({id: "platform.shareToDrawer.toast"}))
    tracking.share({source, type, entity_id})
    onClose()
  }

  return (
    <>
      <ToastAlert />
      <Drawer open={show} onClose={onClose} direction="bottom" zIndex={1050}>
        <Spacing padding={1.5}>
          {showAlert && <Alert type={AlertTypes.warning} title={alertText} onHide={() => setShowAlert(false)} />}
          <Flex gap={1} alignItems="center" marginBottom={2}>
            <Icon icon={IconTypes.shareTo} size={16} />
            <Body onClick={handleClickShare}>
              <FormattedMessage id="platform.shareToDrawer.shareTo" />
            </Body>
          </Flex>
          <CopyToClipboard text={url}>
            <Flex onClick={handleCopyClick} gap={1} alignItems="center">
              <Icon icon={IconTypes.copy} size={16} />
              <Body>
                <FormattedMessage id="platform.shareToDrawer.copyLink" />
              </Body>
            </Flex>
          </CopyToClipboard>
        </Spacing>
      </Drawer>
    </>
  )
}

export default ShareToDrawer
